import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const jamf = defineConnector({
  identifier: "jamf",
  name: "Jamf",
  tagLine: "Apple device management",
  keywords: "jamf pro casper mdm apple mac macos ios device management",
  logo,
  protocol: "http",
  tags: ["featured", "it"],
  defaultUrlPattern: () => "https://[^/]*\\.jamfcloud\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials in Jamf Pro",
      items: [
        {
          kind: "markdown",
          content:
            "In Jamf Pro, go to **Settings → System → API Roles and Clients**. Create a new API client with the permissions you need. Copy the Client ID and Client Secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Instance URL",
          required: true,
          placeholder: "yourcompany.jamfcloud.com",
          target: { kind: "configuration", field: "instance" },
          helperText:
            "Your Jamf Pro instance URL (e.g., yourcompany.jamfcloud.com)",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ instance }) => `https://${instance}/api/oauth/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ instance }) => `https://${instance}/api/v1/jamf-pro-version`,
  },
  publicEnvVars: ({ instance }) => ({
    JAMF_URL: instance ? `https://${instance}` : "",
  }),
});
